export default __webpack_public_path__ + "static/media/realizations.3331b63a.svg";